/** 路由组件的基类配置 */

export default
{
  data()
  {
    return {
      routeTitle: ''
    }
  },
  created()
  {
    this.initRoutes()
  },
  watch:
  {
    '$route': function(to, from)
    {
      this.initRoutes()
      this.onRouteChange(to, from)
    }
  },
  methods:
  {
    /**
     * 初始化参数对象params
     * @method
     */
    initRoutes()
    {
      this.params = cx.base.extend({}, this.getInitPara(), this.$route.query)
      this.routeTitle = this.getPlugTitle()
    },

    /**
     * 关闭路由(不调用回调函数)
     * @method
     */
    close()
    {
      this.$router.back()
    },

    getInitPara()
    {
      return this.getPlugDef().initpara
    },

    /**
     * 获取该路由自身的定义对象
     * @method
     * @returns {Object}                路由定义对象
     */
    getPlugDef()
    {
      return this.$route.matched.find(item => `${item.meta.plugDef.dir}${item.meta.plugDef.classurl}` === this.getComPath()).meta.plugDef
    },

    /**
     * 获取该路由自身的名字
     * @method
     * @returns {String}                路由定义的名字
     */
    getPlugName()
    {
      return this.getPlugDef().name
    },

    /**
     * 获取该路由自身的Title
     * @method
     * @returns {String}                路由定义的Title
     */
    getPlugTitle()
    {
      return this.getPlugDef()[cx.base.locale('titlec', 'titlee')]
    },

    /**
     * 取路由的根DOM节点
     * @method
     * @returns {Object}                对话框句柄
     */
    getRootDom()
    {
      return this.$el
    },

    /**
     * 回调函数-出现错误
     * @method
     */
    onError(ret)
    {
      this.$processing.close()
      this.$showRet(ret)
    },

    /**
     * 当前路由发生变化时的响应函数
     * @method
     * @param   {Object}    to    变化后 的路由属性对象
     * @param   {Object}    from  变化前 的路由属性对象
     */
    onRouteChange(to, from)
    {

    }
  }
}



// WEBPACK FOOTER //
// ./src/router/IRouteBase.js